export function formatDateProgram(date: string) {
  return new Date(date).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
  });
}

export function formatDateFlight(date: string) {
  const [datePart, timePart] = date.split(' ');
  const [year, month, day] = datePart.split('-');
  const [hours, minutes, seconds] = timePart.split(':');
  const formattedDate = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const formattedTime = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
  });
  return `${formattedDate}, ${formattedTime}`;
}

export function formatDateDMY(date: string) {
  if (date === null) {
    return 'N/A';
  }

  let parsedDate: Date;

  if (date.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
    // YYYY-MM-DD HH:MM:SS format
    const [datePart, timePart] = date.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');
    parsedDate = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
  } else if (date.match(/^\d{2}-\d{2}-\d{4}$/)) {
    // DD-MM-YYYY format
    const [day, month, year] = date.split('-');
    parsedDate = new Date(`${year}-${month}-${day}`);
  } else if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
    // YYYY-MM-DD format
    const [year, month, day] = date.split('-');
    parsedDate = new Date(`${year}-${month}-${day}`);
  } else {
    return 'Invalid date format';
  }

  return parsedDate.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function formatDateGetTime(date: string) {
  return new Date(date).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
  });
}
